import BaseService from './BaseService'

class TaxRuleService extends BaseService {
  constructor() {
    super('/locations')
  }

  async getLocationTaxRules(locationId) {
    return this.customRequest('get', `/${locationId}/tax-rules`)
  }

  async createLocationTaxRule(locationId, payload) {
    return this.customRequest('post', `/${locationId}/tax-rules`, payload)
  }

  async updateLocationTaxRule(locationId, ruleId, payload) {
    return this.customRequest('put', `/${locationId}/tax-rules/${ruleId}`, payload)
  }

  async deleteLocationTaxRule(locationId, ruleId) {
    return this.customRequest('delete', `/${locationId}/tax-rules/${ruleId}`)
  }
}

export const taxRuleService = new TaxRuleService()
